import React, { useState } from "react";
import EventsTopActions from "../../../components/crm/components/events/EventsTopActions";
import EntityFormModal from "../../../components/crm/forms/EntityFormModal";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import CrmTemplate from "../../../components/crm/CrmTemplate";
import eventsData from "../../../components/crm/events_data.json";
import EventsTable from "./EventsTable";
import Calender from "./Calender";
import moment from "moment";
import { Views } from "react-big-calendar";

var flatten = require("flat");

const Events = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [entityModalVisible, setEntityModalVisible] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null);
  const [mode, setMode] = useState("new");
  const [currentDate, setCurrentDate] = useState(moment());
  const [calenderView, setCalenderView] = useState(Views.DAY);

  const onLaunchEntityModal = (record, val) => {
    if (record) {
      const flattenItem = flatten(record, { safe: true });
      setActiveRecord(flattenItem);
    }
    setEntityModalVisible(true);
    setMode(val);
  };

  const hideLeadModal = () => {
    setEntityModalVisible(false);
    // dispatch(reload());
    setActiveRecord(null);
  };
  const onNextDate = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
  };
  const onPreviousDate = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
  };
  const onChangeView = (e) => {
    setCalenderView(e.target.value);
  };

  return (
    <CrmTemplate>
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "10px",
          margin: "10px",
          boxShadow: "0 4px 9px 0 rgba(0, 0, 0, 0.05)",
          borderRadius: "5px",
        }}
      >
        <EventsTopActions
          newAction={onLaunchEntityModal}
          onNextDate={onNextDate}
          onPreviousDate={onPreviousDate}
          currentDate={currentDate}
          calenderView={calenderView}
          onChangeView={onChangeView}
        />
        {calenderView ? (
          <Calender
            events={eventsData.map((i) => {
              return {
                start: new Date(i.start_date),
                end: new Date(i.end_date),
                title: i.subject,
              };
            })}
            calenderView={calenderView}
            currentDate={currentDate}
          />
        ) : (
          <EventsTable
            onLaunchEntityModal={onLaunchEntityModal}
            items={eventsData}
          />
        )}

        <EntityFormModal
          visible={entityModalVisible}
          record={activeRecord}
          hide={hideLeadModal}
          mode={mode}
          entity={"events_schedule"}
        />
      </div>
    </CrmTemplate>
  );
};
export default Events;
